import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Tabs, Tooltip } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import { RightsWrapper } from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class AllSubRatings extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    parentRatings: []
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({ exportParams: params })
      let data = await Request.getSubRatingsDetails({
        ...params,
        regExFilters: []
      })
      this.setState({ total: data.total })
      resolve(data)
    })
  }
  getAllRatings = async () => {
    let response = await Request.getRatingsDetails({
      results: 1000,
      count: 1000
    })
    this.setState({ parentRatings: response.data })
  }
  handleSubmit = e => {
    const { form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateSubRatingsDetails(values)
        } else {
          x = await Request.addSubRatingsDetails(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
          })
          notification.success({
            message: this.state.id
              ? `Rating Updated Successfully`
              : 'Rating Added successfully'
          })
          if (!this.state.id) {
            form.setFieldsValue({
              ratingName: ''
            })
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  deleteRatingsDetails = async data => {
    this.setState({ loading: true })
    await Request.deleteSubRatingsDetails(data)

    this.setState({ loading: false })

    this.table.current.reload()

    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  setRatingsDetailsData(companyDetailId) {
    if (companyDetailId) {
      Request.subRatingDetailsByID({ id: companyDetailId }).then(
        ({ doc, error, message }) => {
          if (!error && doc) {
            this.setState({
              id: doc._id,
              activeTab: '1'
            })

            this.props.form.setFieldsValue({
              ratingName: doc.ratingName,
              parentRatingId: doc.parentRatingId
            })
          } else {
            notification.error({
              message: 'Error Getting Data',
              description: message
            })
          }
        }
      )
    }
  }
  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild })
  }

  componentWillMount() {

  }

  async componentDidMount() {
    await this.getAllRatings();
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
      activeTab: value
    })
  }
  render() {
    const {
      form: { getFieldDecorator }
    } = this.props
    const { id, parentRatings } = this.state;

    const inputTypes = {
      fields: [
        {
          label: "Parent Rating",
          key: "parentRatingId",
          type: "select",
          showSearch: true,
          required: true,
          allowClear: true,
          keyAccessor: (x) => x._id,
          valueAccessor: (x) => x.ratingName,
          options: this.state.parentRatings ? this.state.parentRatings : {},
          onChange: (v) => {
            this.props.form.setFieldsValue({ parentRatingId: v });
          },
        },
        {
          label: 'Tag Name',
          key: 'ratingName',
          required: true
        }
      ]
    };

    const columns = [
      {
        title: 'Tag Name',
        key: 'ratingName',
      },
      {
        title: 'Parent Rating Name',
        key: 'parentRatingId',
        dataIndex: "parentRatingId",
        filters: parentRatings && parentRatings.map((x) => ({ value: x._id, text: x.ratingName })),
        render: (text, record) => {
          return (
            <div>
              <div>{record.parentRatingId != null ? record.parentRatingId.ratingName : ""}</div>
            </div>
          )
        }
      },
      {
        title: 'Updated By',
        key: 'lastUpdatedByName',
        dataIndex: 'lastUpdatedByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          record.businessId ?
            <React.Fragment>
              <RightsWrapper myRight={'ratings.edit'}>
                <Tooltip title="Edit Rating">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    onClick={() => {
                      this.setRatingsDetailsData(record._id)
                    }}
                    icon="edit"
                  />
                </Tooltip>
              </RightsWrapper>
              <RightsWrapper myRight={'ratings.delete'}>
                <Tooltip title="Delete Rating">
                  <Popconfirm
                    title="Are you sure delete this Rating?"
                    onConfirm={() => {
                      this.deleteRatingsDetails({ _id: record._id })
                    }}
                    okText="Yes"
                    cancelText="No">
                    <Button
                      className={styles.btn}
                      shape="circle"
                      icon="delete"
                    />
                  </Popconfirm>
                </Tooltip>
              </RightsWrapper>
            </React.Fragment>
            : null
        )
      }
    ]
    return (
      <PageHeaderWrapper title={`Rating Tags `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Tags`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{ scroll: { x: 900 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>

            <TabPane tab={(id ? 'Edit' : 'Add') + ' Tag'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{ marginBottom: 10, marginLeft: '1%' }}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllSubRatings
